import { Doughnut } from 'vue-chartjs'

export default {
  name: 'doughnut-chart',

  mixins: [Doughnut]
}
